import { forwardRef, type Ref, type SVGProps } from "react";

function SvgPlane(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m6.177 7.258 8.226-4.591M5.929 7.214 2.39 3.457a.667.667 0 0 1 .485-1.124h10.962c.515 0 .836.559.576 1.003l-5.628 9.636a.667.667 0 0 1-1.218-.157L6.085 7.492a.7.7 0 0 0-.156-.278"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgPlane);
export default ForwardRef;
